export const parseRating = (r) => {
    return parseFloat(r / 20).toPrecision(2)
}
